function fn_part_form_newsletter() {
    var $fn = $(".part_form_newsletter");

    if ($fn.length) {
        $fn.find("input").focus(function () {
            $(this).closest($fn).addClass("mod--focus");
        }).blur(function() {
            $(this).closest($fn).removeClass("mod--focus");
        });
    }
}